<div #documentList>
  <ng-container>
    <artemis-customer-document-list (editDocument)="editDocumentHandler($event)"></artemis-customer-document-list>
  </ng-container>
</div>
<ng-container ></ng-container>
<div #uploadForm>
  <ng-container *ngIf="isShowDocumentUpdate">
    <div class="update-document-card">
      <artemis-document-update
        (updatedDocumentOutput)="documentUpdated($event)"
        [documentTypes]="documentTypes"
        [authenticities]="authenticites"
        [uploadedDocument]="currentEditCustomerDocument">
      </artemis-document-update>
    </div>
  </ng-container>
</div>
